const state = {
  active: null,
  data: null
}

const mutations = {
  open(state, { modal, data }) {
    state.active = modal
    state.data = data
  },
  close(state) {
    state.active = null
    state.data = null
  },

}

export default {
  namespaced: true,
  state,
  mutations
}
